import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Paper, Modal, Button } from "@mui/material";

function ImagePage() {
  const location = useLocation();
  // Try to get the image data from navigation state; if missing, use localStorage.
  let imageData = location.state;
  if (!imageData) {
    const record = localStorage.getItem("userPhotoData");
    if (record) {
      const parsed = JSON.parse(record);
      imageData = parsed.data;
    }
  }

  if (!imageData || !imageData.imageSrc || !imageData.links) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6" sx={{ color: "white" }}>
          No images found. Please capture an image first.
        </Typography>
      </Box>
    );
  }

  const { imageSrc, clusterNumber, confidence, links } = imageData;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [open, setOpen] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [currentImage, setCurrentImage] = useState("");

  const handleOpen = (src) => {
    setCurrentImage(src);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentImage("");
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(currentImage, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: { "Content-Type": "application/octet-stream" },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;

      const nameSplit = currentImage.split("/");
      const fileName = decodeURIComponent(nameSplit.pop());

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Error while downloading the image", error.message);
    }
  };

  return (
    <div className="image-page-container">
      <Box
        component="div"
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
      >
        <img
          src={imageSrc}
          alt="Captured"
          style={{ width: "50%", borderRadius: "8px" }}
        />

        <Paper
          elevation={3}
          sx={{
            marginTop: 2,
            padding: 2,
            background: "rgba(40, 29, 68, 0.8)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
          }}
        >
          <Typography variant="h6" sx={{ color: "white" }}>
            Cluster: {clusterNumber}
          </Typography>
          <Typography variant="h6" sx={{ color: "white" }}>
            Confidence: {confidence.toFixed(1)}
          </Typography>
        </Paper>

        <Box sx={{ marginTop: 4, width: "100%", textAlign: "center" }}>
          <Typography variant="h5" sx={{ marginBottom: 2, color: "white" }}>
            Image Gallery
          </Typography>
          <div
            className="image-gallery"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "10px",
              justifyItems: "center",
            }}
          >
            {links.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`image-${index}`}
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => handleOpen(src)}
              />
            ))}
          </div>
        </Box>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "16px",
            padding: 3,
            outline: "none",
            boxShadow: 24,
            textAlign: "center",
            maxWidth: "90%",
            maxHeight: "90%",
          }}
        >
          <img
            src={currentImage}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: "70vh",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.open(currentImage, "_blank")}
            sx={{ marginRight: 1 }}
          >
            View Full Size
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDownload}
          >
            Download
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default ImagePage;
